module.exports = __webpack_public_path__ + "static/media/useCase53x.b59de610.png";